import React, { Component } from 'react';

class BajaCuentaConfirmada extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {cuenta} = this.props;

        if(!cuenta){
            return <div className='loading'></div>
        }

        return (  
        <div className="contenedorDatosIntegranteIndividualCuenta top-padding-xs">
           <div className= "CuentaSeleccionContainer bottom-separator-xs bottom-separator">
                <div className="contenedorDatosBajaCuentaIzq">
                    {this.props.esConfirmacion ? <div>Se registró exitosamente la solicitud de baja. Se procederá a realizar el cierre definitivo de la cuenta.</div> : <div style={{display:"none"}}></div>}{/*SE UTILIZÓ EL TERNARIO EN VEZ DE && PARA LA REUTILIZACIÓN DE UNA CLASE QUE TIENE SELECTOR CON NTH CHILD*/}
                    <div>
                        <label>Motivo</label>
                        <div>{cuenta.MotivoBaja ? cuenta.MotivoBaja : " - " }</div>
                    </div>
                    <div>
                        <label>Comentario adicional</label>
                        <div>{cuenta.ComentariosBaja ? cuenta.ComentariosBaja : " - " }</div>
                    </div>
                </div>
                <div className='contenedorDatosBajaCuentaDer'>
                    <div>Registro de baja</div>
                    <div><b>{cuenta.BajaId}</b></div>                
                </div>
           </div>
           <div>
                <span className="icon-ti-user-icon-persona-cyan"></span>&nbsp;{"Baja:" +  cuenta.FechaBaja + " por " + cuenta.UsuarioBaja}
           </div>
        </div>);
    }
}
 
export default BajaCuentaConfirmada;